const routerArr = [
    {
        path: '/bjyStudent',
        name: 'bjyStudent',
        meta: { title:'直播间' , login:true },
        component: () => import(/* webpackChunkName: 'education' */ './page/bjyStudent.vue'),
    },
  {
    path: '/liveList',
    name: 'liveList',
    meta: { title:'直播列表' ,login:true},
    component: () => import(/* webpackChunkName: 'live' */ './page/liveList.vue'),
  },
  {
      path: '/watchLive',
      name: 'watchLive',
      meta: { title:'观看直播',login:true },
      component: () => import(/* webpackChunkName: 'live' */ './page/watchLive.vue'),
  },
  // 百家云回放
    {
        path: '/bjyLivePlayBack',
        name: 'bjyLivePlayBack',
        meta: { title:'回放' ,login:true},
        component: () => import(/* webpackChunkName: 'live' */ './page/bjyLivePlayBack.vue'),
    },
  {
      path: '/replay',
      name: 'replay',
      meta: { title:'回放' ,login:true},
      component: () => import(/* webpackChunkName: 'live' */ './page/replayCopy.vue'),
  },
  {
      path: '/liveSkip',
      name: 'liveSkip',
      meta: { title:'ios跳转提示' ,login:true},
      component: () => import(/* webpackChunkName: 'live' */ './page/liveSkip.vue'),
    }
]
export default routerArr
